/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: TimelineLegend.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-TIMELINE
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * TimelineLegend - Frontend UI module: TimelineLegend.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-14 - упрощённая легенда для режима сводки (UC-017).
 * END_CHANGE_SUMMARY
 */

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { TIMELINE_VIEW_MODE } from '../timelineUtils';

const detailedItems = [
  { label: 'Рабочий день по задаче', bg: '#90a9b0' },
  { label: 'Выходные и праздники', bg: 'grey.200' },
  { label: 'Отсутствия сотрудника', bg: 'grey.400' },
  { label: 'Сегодня', bg: (theme) => alpha(theme.palette.primary.main, 0.5) },
  { label: 'Внесены фактические часы', outlineColor: 'warning.main' },
];

const overviewItems = [
  { label: 'Срок задачи', bg: '#5a7d8a' },
  { label: 'Выходные и праздники', bg: 'grey.200' },
  { label: 'Сегодня', bg: (theme) => alpha(theme.palette.primary.main, 0.5) },
];

/* START_METHOD_TimelineLegend */
/* START_CONTRACT: TimelineLegend
 * PURPOSE: Легенда цветовых обозначений диаграммы Ганта таймлайна.
 * INPUTS: {}.
 * OUTPUTS: { JSX.Element - легенда }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-TIMELINE
 * END_CONTRACT: TimelineLegend
 */
export default function TimelineLegend({ viewMode = TIMELINE_VIEW_MODE.DETAILED }) {
  const items = viewMode === TIMELINE_VIEW_MODE.OVERVIEW ? overviewItems : detailedItems;
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {items.map((item) => (
        <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: 0.5,
              border: item.outlineColor ? '2px solid' : '1px solid',
              borderColor: item.outlineColor ?? 'divider',
              bgcolor: item.bg ?? 'transparent',
            }}
          />
          <Typography variant="caption" color="text.secondary">
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
/* END_METHOD_TimelineLegend */
